module.exports = __webpack_public_path__ + "static/img/product-10.63f2e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-10.png
// module id = O/e3
// module chunks = 0